const EXCEL_MIME_TYPES = new Set([
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
]);

const EXCEL_EXTENSIONS = ['.xlsx', '.xls'];

export const isExcelFile = (file: File) => {
    const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

    return EXCEL_MIME_TYPES.has(file.type) || EXCEL_EXTENSIONS.includes(extension);
};
